// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles_flexbox__1u7Se{\n    display:flex;\n    grid-gap:1rem;\n    gap:1rem\n}", "",{"version":3,"sources":["webpack://src/components/Settings/Sms/AddBotDialog/styles.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAO;IAAP;AACJ","sourcesContent":[".flexbox{\n    display:flex;\n    gap:1rem\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexbox": "styles_flexbox__1u7Se"
};
export default ___CSS_LOADER_EXPORT___;
